module.exports = __webpack_public_path__ + "img/hino_logo.c4b110aa.svg";